export const useToolbarAction = () =>
  'inline-flex rounded-xl ts-l6 text-black dark:text-white fill-current justify-center items-center h-7 cursor-pointer hover:bg-white dark:hover:bg-black focus-visible:ring-2 ring-blue ring-inset disabled:opacity-50';
